import { handleResponse, handleBlobResponse } from "utils/utils";
import { authService } from "services";
import i18n from "i18n";

const statusByLang = {
    es: { approved: "Aprobado", canceled: "Cancelado", denied: "Denegado", paid: "Pagado", pending: "Pendiente" },
    en: { approved: "Approved", canceled: "Canceled", denied: "Denied", paid: "Paid", pending: "Pending" },
    ca: { approved: "Aprobado", canceled: "Cancelado", denied: "Denegado", paid: "Pagado", pending: "Pendiente" },
};

export const expStatus = new Proxy({}, {
    get(_, key) {
        const lang = (i18n.language || "es").split("-")[0];
        return (statusByLang[lang] || statusByLang.es)[key];
    },
});

function authHeaders(extra = {}) {
    const lang = (i18n.language || "es").split("-")[0];
    return {
        Authorization: `Bearer ${authService.token.access_token}`,
        "Accept-Language": lang,
        ...extra,
    };
}

export const expensesService = {
    getAll,
    getById,
    add,
    update,
    remove,
    getAllStatus,
    getAttachment,
    updateAttachments,
    removeAttachment,
    exportList,
};

function buildSearchQuery(options = {}) {
    const query = new URLSearchParams({ sort: "-day" });
    const { provider_id, expense_type_id, status, date_from, date_to, employee_id, page, page_size, time_zone } = options;

    if (provider_id) query.append("provider_id", provider_id);
    if (expense_type_id) query.append("expense_type_id", expense_type_id);
    if (employee_id) query.append("employee_id", employee_id);
    if (date_from) query.append("expense_day_from", date_from);
    if (date_to) query.append("expense_day_to", date_to);
    if (page !== undefined) query.append("page", page);
    if (page_size !== undefined) query.append("page_size", page_size);
    if (time_zone) query.append("time_zone", time_zone);

    if (status) {
        const statuses = Array.isArray(status) ? status : [status];
        statuses.forEach((item) => query.append("expense_status", item));
    }

    return `?${query.toString()}`;
}

// get expenses
function getAll(options) {
    const requestOptions = {
        method: "GET",
        headers: authHeaders(),
    };

    return fetch(`${global.BASE_API}expenses${buildSearchQuery(options)}`, requestOptions).then(handleResponse);
}

function exportList(options) {
    const requestOptions = {
        method: "GET",
        headers: authHeaders(),
    };

    return fetch(`${global.BASE_API}expenses/export${buildSearchQuery(options)}`, requestOptions).then(handleResponse);
}

// get expense by id
function getById(id) {
    const requestOptions = {
        method: "GET",
        headers: authHeaders(),
    };

    return fetch(`${global.BASE_API}expenses/${id}`, requestOptions).then(handleResponse);
}

// add new expense
function add(expense) {
    const requestOptions = {
        method: "POST",
        headers: authHeaders({ "Content-Type": "application/json" }),
        body: JSON.stringify(expense),
    };

    return fetch(`${global.BASE_API}expenses`, requestOptions).then(handleResponse);
}

// update expense
function update(expense) {
    const requestOptions = {
        method: "PUT",
        headers: authHeaders({ "Content-Type": "application/json" }),
        body: JSON.stringify(expense),
    };

    return fetch(`${global.BASE_API}expenses/${expense.id}`, requestOptions).then(handleResponse);
}

// remove expense
function remove(id) {
    const requestOptions = {
        method: "DELETE",
        headers: authHeaders(),
    };

    return fetch(`${global.BASE_API}expenses/${id}`, requestOptions).then(handleResponse);
}

// get one attachment by uuid
function getAttachment(expenseId, attachmentId) {
    const requestOptions = {
        method: "GET",
        headers: authHeaders(),
    };

    return fetch(`${global.BASE_API}expenses/${expenseId}/attachments/${attachmentId}`, requestOptions).then(handleBlobResponse);
}

// upload attachments to an expense
function updateAttachments(id, formData) {
    const requestOptions = {
        method: "POST",
        headers: authHeaders(),
        body: formData,
    };

    return fetch(`${global.BASE_API}expenses/${id}/attachments`, requestOptions).then(handleResponse);
}

// delete attachment from expense
function removeAttachment(expenseId, attachmentId) {
    const requestOptions = {
        method: "DELETE",
        headers: authHeaders(),
    };

    return fetch(`${global.BASE_API}expenses/${expenseId}/attachments/${attachmentId}`, requestOptions).then(handleResponse);
}

// get expense status
function getAllStatus() {
    const requestOptions = {
        method: "GET",
        headers: authHeaders(),
    };

    return fetch(`${global.BASE_API}expenses/status`, requestOptions).then(handleResponse);
}
